/**
 * Created by razial on 23.07.2026.
 */

const PrefabEditorHelper = {
    transformToFrameSpace: function () {
        const win = cc.winSize;
        const frame = cc.view.getFrameSize();
        return cc.affineTransformMake(frame.width / win.width, 0, 0, -frame.height / win.height, 0, frame.height);
    },

    transformFromFrameSpace: function () {
        const win = cc.winSize;
        const frame = cc.view.getFrameSize();
        return cc.affineTransformMake(win.width / frame.width, 0, 0, -win.height / frame.height, 0, win.height);
    },

    assetPreview: function (resource, type) {
        const node = this.createPreviewNode(resource, type);
        if (!node) {
            return;
        }

        const box = node.getBoundingBox();
        const width = Math.max(1, Math.ceil(box.width));
        const height = Math.max(1, Math.ceil(box.height));

        node.setPosition(node.x - box.x, node.y - box.y);

        const winSize = cc.size(cc.director._winSizeInPoints.width, cc.director._winSizeInPoints.height);
        cc.director._winSizeInPoints = cc.size(width, height);

        try {
            const rt = new cc.RenderTexture(width, height);
            rt.setAnchorPoint(0, 0);
            rt.setPosition(0, 0);

            rt.beginWithClear(0, 0, 0, 0);
            node.visit();
            rt.end();

            const preview = this.renderTextureToDataURL(rt, width, height);

            rt.cleanup();

            return preview;
        } finally {
            cc.director._winSizeInPoints = winSize;
            cc.director.setViewport();

            Object.values(cc.shaderCache._programs).forEach((program) => {
                program._projectionUpdated = -1;
            });
        }
    },

    createPreviewNode: function (resource, type) {
        if (type === "frames") {
            return new cc.Sprite(resource);
        }

        if (type === "jsons") {
            const data = resource.getJson();
            if (!data || !data.skeleton || !data.bones) {
                return undefined;
            }

            const spine = new cleverapps.Spine(resource);

            const animations = spine.listAnimations();

            const animation = animations.find((animation) => animation.includes("idle"))
                || animations.find((animation) => animation.includes("animation"));

            if (animation) {
                spine.setAnimation(0, animation, false);
            }

            return spine;
        }

        return undefined;
    },

    renderTextureToDataURL: function (rt, width, height) {
        const gl = cc._renderContext;

        const pixels = new Uint8Array(width * height * 4);
        gl.bindFramebuffer(gl.FRAMEBUFFER, rt._renderCmd._fBO);
        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);

        for (let i = 0; i < pixels.length; i += 4) {
            const alpha = pixels[i + 3];
            if (alpha > 0 && alpha < 255) {
                pixels[i] = Math.min(255, Math.round((pixels[i] * 255) / alpha));
                pixels[i + 1] = Math.min(255, Math.round((pixels[i + 1] * 255) / alpha));
                pixels[i + 2] = Math.min(255, Math.round((pixels[i + 2] * 255) / alpha));
            }
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext("2d");
        const image = context.createImageData(width, height);

        const rowBytes = width * 4;
        for (let row = 0; row < height; row++) {
            const src = row * rowBytes;
            const dst = (height - row - 1) * rowBytes;
            image.data.set(pixels.subarray(src, src + rowBytes), dst);
        }
        context.putImageData(image, 0, 0);

        return {
            dataUrl: canvas.toDataURL(),
            width,
            height
        };
    },

    hitTest: function (shadowNode, point) {
        const children = shadowNode.getChildren();
        for (let i = children.length - 1; i >= 0; i -= 1) {
            const hit = this.hitTest(cleverapps.prefabEditor.getShadowNode(children[i]), point);
            if (hit) {
                return hit;
            }
        }

        const nodes = shadowNode.listNodes();
        for (let i = nodes.length - 1; i >= 0; i -= 1) {
            const node = nodes[i];
            if (node.isVisible() && cc.rectContainsPoint(node.getBoundingBoxToWorld(), point)) {
                const bridge = ComponentMap.get(node, ShadowNodeBridge);
                if (bridge) {
                    return bridge.getShadowNode();
                }
            }
        }

        return undefined;
    }
};